import { PreviewableImage } from '@spotify/confidence-core-react';
import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import { Variant } from './types';

import styles from './ImageSection.module.css';

export const ImageSection = ({
  oldVariant,
  newVariant,
}: {
  oldVariant?: Variant;
  newVariant?: Variant;
}) => {
  if (!oldVariant) {
    if (newVariant?.imageUri) {
      return (
        <ActivityItem.Section label="Image">
          <PreviewableImage src={newVariant.imageUri} alt="New" />
        </ActivityItem.Section>
      );
    }

    return null;
  }

  if (!newVariant) {
    if (oldVariant?.imageUri) {
      return (
        <ActivityItem.Section label="Image">
          <PreviewableImage src={oldVariant.imageUri} alt="Old" />
        </ActivityItem.Section>
      );
    }

    return null;
  }

  const oldImageUri = oldVariant?.imageUri;
  const newImageUri = newVariant?.imageUri;

  if (!oldImageUri && !newImageUri) {
    return null;
  }

  if (oldImageUri === newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <PreviewableImage src={oldImageUri} alt="Variant" />
      </ActivityItem.Section>
    );
  } else if (oldImageUri && newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <PreviewableImage
          src={oldImageUri}
          alt="Old"
          className={styles.removedImage}
        />
        <PreviewableImage
          src={newImageUri}
          alt="New"
          className={styles.addedImage}
        />
      </ActivityItem.Section>
    );
  } else if (oldImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <PreviewableImage
          src={oldImageUri}
          alt="Old"
          className={styles.removedImage}
        />
      </ActivityItem.Section>
    );
  } else if (newImageUri) {
    return (
      <ActivityItem.Section label="Image">
        <PreviewableImage
          src={newImageUri}
          alt="New"
          className={styles.addedImage}
        />
      </ActivityItem.Section>
    );
  }

  return null;
};
